import createTitanClient from '@narvar/titan-client';
import { store } from '../store';
import { fingerprint } from './fingerprint';

const { name: retailer } = window.retailerJSON;
let titanClient = null;

const loadTitanClient = async () => {
  const anonymousId = await fingerprint();
  titanClient = createTitanClient({
    url: process.env.TITAN_URL,
    sourceWriteKey: retailer,
    anonymousId,
  });
  return titanClient;
};

export const titan = {
  event: async (event, data) => {
    if (!titanClient) {
      await loadTitanClient();
    }
    try {
      const { orderInfo: { currentOrderNumber } = {}, userPreferences: { profile } = {} } =
        store.getState();
      const guestId = currentOrderNumber ? `${retailer}::${currentOrderNumber}` : null;
      const profileId =
        profile?.primary_email?.is_verified && profile?.profile_id ? profile.profile_id : null;

      return titanClient.track({
        event,
        channel: 'web',
        type: 'track',
        context: {},
        userId: profileId || guestId,
        properties: {
          narvar_product_context: 'returns',
          ...data,
        },
      });
    } catch (err) {
      return console.log(err);
    }
  },
};
